export const getPagination = ({ pagination }) => pagination;
export const comissao_empty = () => ({
  nome: "",
  tipo: "permanente",
  conselho_id: null,
  objetivo: "",
  atribuicoes: "",
  arquivos: [],
  membros: [],
});
